import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import LegalEntitiesApi from '@/services/apiServiceModules/legalEntitiesApi'
const legalEntitiesApi = new LegalEntitiesApi()

export default class LegalEntitiesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.LEGAL_ENTITIES, legalEntitiesApi, {
			useCache: true,
		})
	}
}
